export default __webpack_public_path__ + "static/media/PlayH2.4e48b8ed.png";